import { AuthGuard } from "app/auth/helpers";
import { SingleStaffReportComponent } from "./pages/single-staff-report/single-staff-report.component";
import { WorkdayUsersReportsListComponent } from "./pages/staff-reports-list/workday-users-reports-list.component";
import { SingleUserReportComponent } from "./pages/single-user-report/single-user-report.component";
import { CategoriesExtraHoursComponent } from "./pages/categories-extra-hours/categories-extra-hours.component";
import { ArchiveUserReportsComponent } from "./pages/my-archive/my-archive.component";
import { ArchiveReportViewComponent } from "./pages/archive-report-view/archive-report-view.component";
import { CollaboratorReportViewComponent } from "./pages/collaborator-report-view/collaborator-report-view.component";
import { CollaboratorsByProviderReportsListComponent } from "./pages/collaborators-by-provider-reports-list/collaborators-by-provider-reports-list.component";
import { CollaboratorsByProvidersReportComponent } from "./pages/collaborators-by-providers-report/collaborators-by-providers-report.component";
import { IRoute } from "app/auth/models/utils-interfaces";

const workdayReportRoutes: IRoute[] = [
  {
    path: "dashboard/workday-report/user-report",
    component: SingleUserReportComponent,
    canActivate: [AuthGuard],
    capability: "show_menu_workday_user_report",
    data: { animation: "flatpickr" },
  },
  {
    path: "dashboard/workday-report/user-report/:id",
    component: SingleUserReportComponent,
    canActivate: [AuthGuard],
    capability: "show_menu_workday_user_report",
    data: { animation: "flatpickr" },
  },
  {
    path: "dashboard/workday-report/users-reports",
    component: WorkdayUsersReportsListComponent,
    canActivate: [AuthGuard],
    capability: "show_menu_workday_user_report",
    data: { animation: "flatpickr" },
  },
  // Visualizzazione rapportino staff
  {
    path: "dashboard/workday-report/single/:id",
    component: SingleStaffReportComponent,
    canActivate: [AuthGuard],
    capability: "show_menu_workday_user_report",
    data: { animation: "flatpickr" },
  },
  // categorie ore extra rapportino
  {
    path: "dashboard/workday-report/categories-list",
    component: CategoriesExtraHoursComponent,
    canActivate: [AuthGuard],
    capability: "view_future_employees",
    data: { animation: "flatpickr" },
  },
  {
    path: "dashboard/workday-report/my-archive",
    component: ArchiveUserReportsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/workday-report/archive-view/:id",
    component: ArchiveReportViewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/workday-report/collaborator/user-report",
    component: CollaboratorReportViewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/workday-report/collaborators-by-providers-reports",
    component: CollaboratorsByProviderReportsListComponent,
    canActivate: [AuthGuard],
    capability: "show_menu_workday_user_report",
    data: { animation: "flatpickr" },
  },
  {
    path: "dashboard/workday-report/collaborator-by-provider-report/:id",
    component: CollaboratorsByProvidersReportComponent,
    canActivate: [AuthGuard],
    capability: "show_menu_workday_user_report",
    data: { animation: "flatpickr" },
  },
];
export default workdayReportRoutes;
